import { defineMessages } from 'react-intl'

const scope = `procurify.modules.vendor.components.PDFLabelSetSelect`

export default defineMessages({
  PDFLabelSetSelectPlaceholder: {
    id: `${scope}.PDFLabelSetSelectPlaceholder`,
    defaultMessage: 'Select an option',
  },
  PDFLabelSetDefaultLabel: {
    id: `${scope}.PDFLabelSetDefaultLabel`,
    defaultMessage: '(Default)',
  },
})
